export default __webpack_public_path__ + "static/media/roadmap1.dea8c5bf.png";